module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Component-9ab5d4a5dec9ecc83e45cd2f548d0d1f.svg";